module.exports = __webpack_public_path__ + "img/am07.1bdc98a2.jpg";